export const locale = {
    lang: 'pl',
    data: {
        "Products": "Produkty",
        "Sale": "Sprzedaż",
        "Deliveries": "Dostawy",
        "Use": "Zużycie"
    }
};
